import React from 'react';

const Em = ({ children }) => <span style={{ fontWeight: 600 }}>{children}</span>;

const LI_CLS = 'font-pretendard font-normal text-[13px] leading-[1.6] md:text-[22px] md:leading-[26px] text-[#262626]';
const LI_STYLE = { listStyleType: 'disc', letterSpacing: '-0.03em' };

// Figma Frame 5: 1200x160px, bg #F5F5F5, border-radius 8px, Pretendard 400 22px, leading 26px, tracking -0.03em
const DisclaimerBox = () => (
  <div className="w-full bg-[#F5F5F5] rounded-[8px] px-4 py-4 md:px-8 md:py-6">
    <style>{`
      .disclaimer-br { display: block; }
      @media (max-width: 767px) { .disclaimer-br { display: none; } }
    `}</style>
    <ul className="m-0 flex flex-col gap-[6px]" style={{ paddingLeft: 20 }}>
      <li className={LI_CLS} style={LI_STYLE}>
        엔터잡에듀의 강사님들은 대부분 실제 엔터사에서 지속적으로 근무하고 계신 현직자분들로,&nbsp;
        <br className="disclaimer-br" />
        온라인에 정확하게 이력을 공개하기 어려운 분들이 있습니다. 이 점 양해 부탁드립니다.
      </li>
      <li className={LI_CLS} style={LI_STYLE}>
        강사님 이력에서 &apos;대형 엔터테인먼트&apos;로 표기된 회사는 <Em>SM, JYP, HYBE, YG 중 한 곳을 의미</Em>
        하며,&nbsp;
        <br className="disclaimer-br" />
        강의 구매 후 이력에 허위 사실이 발견될 경우 <Em>엔터잡에듀에서 전액 환불</Em>해드립니다.
      </li>
    </ul>
  </div>
);

export default DisclaimerBox;
